function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChatbubbles = function SvgChatbubbles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M1.1 9.6c.1.2.2.4.2.6l-.7 3.3c-.1.4.2.6.4.5l3.6-1.9c.2-.1.4-.1.5-.1.6.1 1.2.2 1.9.2 3.9 0 7-2.5 7-5.6S10.9 1 7 1 0 3.5 0 6.6c0 1.1.4 2.1 1.1 3zM13 17.2c-3.2 0-5.9-1.7-6.7-4H7c4.2 0 8-2.8 8-6.6v-.4c2.9.7 5 2.8 5 5.4 0 1.1-.4 2.1-1.1 3-.1.2-.2.4-.2.6l.7 3.3c.1.3-.2.5-.5.4L15.3 17h-.4c-.6.1-1.3.2-1.9.2z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgChatbubbles;